import { e as i, c as m } from "./utils.mjs";
function o(f, a, n, l) {
  return f.params.createElements && Object.keys(l).forEach((e) => {
    if (!n[e] && n.auto === !0) {
      let t = i(f.el, `.${l[e]}`)[0];
      t || (t = m("div", l[e]), t.className = l[e], f.el.append(t)), n[e] = t, a[e] = t;
    }
  }), n;
}
export {
  o as c
};
//# sourceMappingURL=create-element-if-not-defined.mjs.map
